module.exports = __webpack_public_path__ + "static/img/customer_tutorial.84fe038.gif";


//////////////////
// WEBPACK FOOTER
// ./static/images/customer_tutorial.gif
// module id = TbP5
// module chunks = 1